import parseUA from 'zhihu-utilities/lib/ua'
import { loadScript } from 'zhihu-utilities/lib/script'

const ua = parseUA(window.navigator.userAgent)

const initWechat = () => {
  const { href } = window.location
  const WECHAT_SDK_ADDRESS = `https://res.wx.qq.com/open/js/jweixin-1.2.0.js`
  const WECHAT_SDK_CONFIG_API = `https://www.zhihu.com/wechat/jssdkconfig`
  const fetchSDK = () =>
    window.wx ? Promise.resolve() : loadScript(WECHAT_SDK_ADDRESS)
  const fetchSDKConfig = () =>
    fetch(
      `${WECHAT_SDK_CONFIG_API}?url=${encodeURIComponent(href.split('#')[0])}`
    ).then(res => {
      if (res.ok) {
        return res.json()
      }
      throw new Error('Failed to fetch wechat jssdk config')
    })
  const configWechat = config =>
    window.wx &&
    window.wx.config(
      Object.assign({}, config, {
        beta: true,
        jsApiList: ['launchApplication'],
      })
    )
  return fetchSDK()
    .then(fetchSDKConfig)
    .then(configWechat)
}

export const initOpenInApp = () =>
  ua.Wechat ? initWechat() : Promise.resolve()

export default initOpenInApp



// WEBPACK FOOTER //
// ./src/utils/callApp.js